import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=0aa22533&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=js&"
export * from "./Subscribe.vue?vue&type=script&lang=js&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=0aa22533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa22533",
  null
  
)

export default component.exports